
    import Vue from 'vue';
    import { RouterLink } from 'vue-router';
    import AgeService from '@/apps/shared/utils/CheckAges';
    import FilePathService from '@/apps/shared/services/filePath-service';
    import documentTypeService from '@/apps/shared/services/documentType-service';
    import ivaConditionService from '@/apps/shared/services/ivaConditions-service';
    import searchPersonService from '@/apps/shared/services/searchPerson-service';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import localityService from '@/apps/shared/services/locality-service';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';

    export default Vue.extend({
        components: {
            RouterLink,
            WhatsApp,
            XBreadcrumb
        },
        name: 'APinsured-view',
        data() {
            return {
                localityList:
                    function (params) {
                        return localityService.getLocalityList(params)
                    },
                streetName: null,
                numDom: null,
                icono: null,
                showAddInsuredButton: true,
                ownerIsInsured: true,
                beneficiaries: null,
                capital: null,
                coversDetail: [],
                maxSelections: 2,
                primerCuota: 0,
                DataPlan: { planDescription: '' },
                documentTypeList: [{ id: "", text: "" }],
                ivaConditionList: [{ id: "", text: "" }],
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                isNotSelectedDocumentType: true,
                nextButtonDisable: true,
                addPeopleDisable: false,
                addTitularDisable: false,
                messageErrorAge: null,
                currentStep: 2,
                totalStep: 3,
                insuredPeople: [],
                rolRelations: { id: 1, name: "Asegurado" },
                addPeople: false,
                personToAdd: {},
                beneficiaryData: {},
                searchButtonDisable: true,
                personToAddDocTypeSelected: null,
                personToAddNumDoc: null,
                addTitularDisableTooltipText: "",
                addPeopleDisableTooltipText: "",
                peopleToCover: 0,
                titularPerson: null,
                policyOwner: null,
                numDocChange: null,
                numDocExisting: null,
                personToDelete: {},
                localItems: [],
                isPerson: false,
                isJuridico: false,
                multiplePeopleWithSameIdentifier: [],
                personWithSameIdentifierSelected: null,
                premiumWithoutDiscount: null,
                thereIsDiscount: false,
                vigencyStart: "",
                isBeneficiaryMode: false,
                currentBeneficiaryItem: null,
                // Para el error de edad en el modal de selección múltiple
                multiplePeopleError: "",
                personNotExist: false,
                personType: null,
                product: null,
                peopleToCoverHasLocality: true,
                personData: null,
                hasBeneficiaryAddress: false,
                piso: null,
                numDept: null,
                hasDiscount: null,
                referente: null,
            };
        },
        computed: {
          
        },
        created() {
            //this.updateLocalItems();
            this.personToDelete = this.getDefaultPerson();
            this.personToAdd = this.getDefaultPersonToAdd();

            window.globalThis.validateNumDoc = (val) => {
                let valid = true;
                let message = "";

                if (!this.personToAddDocTypeSelected) {
                    return { valid: false, message: "Debe seleccionar un tipo de documento." };
                }

                // Asegurarnos de que val es un string y eliminar espacios innecesarios
                val = String(val || "").trim();  // Aseguramos que 'val' sea un string y lo limpiamos de espacios
                let numericVal = val.replace(/\D/g, "");

                if (this.personToAddDocTypeSelected.id === 'D') {
                    if (numericVal.length !== 7 && numericVal.length !== 8) {
                        this.searchButtonDisable = true;
                        message = numericVal.length > 0 ? "La cantidad de dígitos es incorrecta." : "Este campo es obligatorio.";
                        valid = false;
                    } else {
                        if (this.numDocExisting !== numericVal) {
                            this.numDocChange = true;
                            this.numDocExisting = numericVal;
                        }
                        this.searchButtonDisable = false;
                        message = "";
                        valid = true;
                    }
                } else if (this.personToAddDocTypeSelected.id === 'J') {
                    // Validar CUIT
                    if (numericVal.length !== 11 || !this.validarCuit(numericVal)) {
                        message = "CUIT inválido. Debe tener 11 digitos y comenzar con 30, 33 o 34";
                        valid = false;
                        this.searchButtonDisable = true;
                    } else {
                        this.searchButtonDisable = false;
                        message = "";
                        valid = true;
                    }
                }

                else {
                    this.searchButtonDisable = false;
                }

                if (!val) {
                    this.searchButtonDisable = true;
                }

                return { valid, message };
            };
        },
        methods: {
            validarCuit(cuit) {
                // valida que tenga 11 dígitos numericos
                if (!/^\d{11}$/.test(cuit)) return false;

                // valida prefijo permitido: 30, 33, 34
                const prefix = cuit.substring(0, 2);
                if (!["30", "33", "34"].includes(prefix)) return false;

                // calculo de ultimo numero
                const mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
                let total = 0;

                for (let i = 0; i < 10; i++) {
                    total += parseInt(cuit[i]) * mult[i];
                }

                let resto = total % 11;
                let digito = resto === 0 ? 0 : resto === 1 ? 9 : 11 - resto;

                // Comparar con el ultimo numero ingresado
                return digito === parseInt(cuit[10]);
            },
            getDefaultPerson() {
                return {
                    id: 0,
                    firstName: "",
                    lastName: "",
                    docNum: "",
                    docType: { name: "" },
                    rol: { name: "" },
                    birthday: null,
                    beneficiariesList: []
                };
            },
            getDefaultPersonToAdd() {
                return {
                    isPersonExist: false,
                    activeForm: false,
                    birthday: null,
                    isBirthdayCorrect: true,
                    firstName: "",
                    lastName: "",
                    docNum: "",
                    docTypeSelected: null,
                    email: "",
                    selectedIvaCondition: null,
                    areaCode: "",
                    telephone: null,
                    hasLocality: false,
                    MaximDigitSuperatedDni: false,
                    age: "",
                    selectedLocality: null,
                    address: null,
                    maximDigitSuperatedDni: false,
                    activeFormPersonNotExist: false,
                    isEqualToPolicyOwner: false,
                    isEqualTotitularPerson: false,
                    alreadyExists: false,
                    beneficiaries: null
                };
            },
            disableAcceptNewPersonButton() {
                return (
                    !this.personToAddNumDoc ||
                    !this.personToAddDocTypeSelected ||
                    !this.personToAdd.birthday ||
                    !this.personToAdd.firstName ||
                    !this.personToAdd.lastName ||
                    !this.personToAdd.isBirthdayCorrect
                );
            },
            openCancelModal() {
                this.$refs.cancelModal.open();
            },
            closeCancelModal() {
                this.$refs.cancelModal.close();
            },
            closeDeleteAssuredModal() {
                this.$refs.deleteAssuredModal.close();
                this.resetPersonToDelete();
            },
            resetPersonToDelete() {
                this.personToDelete = this.getDefaultPerson();
            },
            openDeleteAssuredModal(item: any) {
                this.personToDelete = { ...item };
                this.$refs.deleteAssuredModal.open();
            },
            openSelectMultiplePeopleModal(peopleList: any[]) {
                this.isPeopleWithSameIdentifierModalOpen = true;
                this.resetMultiplePeopleModalValues();
                let idCounter = 1;
                this.multiplePeopleWithSameIdentifier = peopleList.map(person => ({
                    id: idCounter++,
                    birthday: person.birthday,
                    firstName: person.firstName,
                    lastName: person.lastName,
                    email: person.email,
                    selectedIvaCondition: person.ivaConditionFiscalId,
                    areaCode: person.phoneAreaCode,
                    telephone: person.phoneNumber,
                    hasLocality: person.hasLocality,
                    address: person.address ? { ...person.address } : null,
                    document: person.document || null,
                    localityName: person.localityName
                }));
                this.$refs.selectMultiplePeopleModal.open();
            },
            resetPersonToAddModal() {
                this.personToAddDocTypeSelected = this.documentTypeList.find((p: any) => p.name.trim() === "DNI");
                this.personToAddNumDoc = "";
                this.resetPersonToAdd();
                this.personToAdd = this.getDefaultPersonToAdd();
            },
            resetMultiplePeopleModalValues() {
                this.multiplePeopleWithSameIdentifier = [];
                this.personWithSameIdentifierSelected = null;
                this.multiplePeopleError = "";
            },
            closeSelectMultiplePeopleModal(flag = true) {
                this.isPeopleWithSameIdentifierModalOpen = false;
                this.resetMultiplePeopleModalValues();
                if (flag) {
                    this.resetPersonToAddModal();
                }
                this.$refs.selectMultiplePeopleModal.close();
            },
            onSelectedClient(id: number) {
                this.personWithSameIdentifierSelected = id;
                const selectedPerson = this.multiplePeopleWithSameIdentifier.find(
                    item => item.id === this.personWithSameIdentifierSelected
                );
                if (!selectedPerson) return;

                if (this.personToAddDocTypeSelected.id != "J") {
                    const ageResult = this.ageCalculate(selectedPerson.birthday, 18, 65);
                    if (!ageResult.success) {
                        this.multiplePeopleError = ageResult.message;
                        return;
                    }
                }

                this.multiplePeopleError = "";

                if (this.isBeneficiaryMode) {                    
                    const list = this.currentBeneficiaryItem.beneficiariesList || [];

                    const dupInThis = list.some(b =>
                        b.docType.id === this.personToAddDocTypeSelected.id &&
                        b.docNum === this.personToAddNumDoc
                    );
                    const selfAsBene =
                        this.currentBeneficiaryItem.docType.id === this.personToAddDocTypeSelected.id &&
                        this.currentBeneficiaryItem.docNum === this.personToAddNumDoc;

                    if (dupInThis || selfAsBene) {
                        this.personToAdd.alreadyExists = true;
                        return;
                    }
                } else {    
                    const alreadyInsured = this.insuredPeople.some(member =>
                        member.docType.id === this.personToAddDocTypeSelected.id &&
                        member.docNum === this.personToAddNumDoc
                    );
                    if (alreadyInsured) {
                        this.personToAdd.alreadyExists = true;
                        return;
                    }
                }

                this.personToAdd.isEqualToPolicyOwner =
                    (this.personToAddNumDoc === this.policyOwner.document.identificationNumber &&
                        this.personToAddDocTypeSelected.id === this.policyOwner.document.identificationTypeCode);

                if (this.ownerIsInsured) {
                    this.personToAdd.isEqualTotitularPerson =
                        (this.personToAddNumDoc === this.titularPerson?.docNum &&
                            this.personToAddDocTypeSelected.id === this.titularPerson?.docTypeSelected?.id);
                }

                selectedPerson.beneficiaries = this.beneficiaries;
                this.setPersonToAdd(selectedPerson);

                if (
                    this.personToAddNumDoc &&
                    this.personToAdd.isBirthdayCorrect &&
                    !this.personToAdd.isEqualToPolicyOwner &&
                    !this.personToAdd.isEqualTotitularPerson &&
                    !this.personToAdd.alreadyExists
                ) {
                    this.finallySetPersonToAddOrEdit();
                    this.closeSelectMultiplePeopleModal();
                } else {
                    this.closeSelectMultiplePeopleModal(false);
                }
            },
            deleteAssured(id: number) {
                const index = this.insuredPeople.findIndex(member => member.id === id);
                if (index !== -1) {
                    this.insuredPeople.splice(index, 1);
                }
                this.closeDeleteAssuredModal();
            },
            closePersonToAddModal() {
                this.$refs.personToAddModal.close();
                if (!this.isPeopleWithSameIdentifierModalOpen) {
                    this.resetPersonModalState();
                }
                const IdCUIT = this.documentTypeList.findIndex(dt => dt.id === 'J');
                if (IdCUIT !== -1) {
                    this.documentTypeList.splice(IdCUIT, 1);
                }
            },
            resetPersonToAdd() {
                this.personToAdd = this.getDefaultPersonToAdd();
            },
            openPersonToAddModal() {
                this.resetPersonModalState(); 
                this.personToAddDocTypeSelected = this.documentTypeList.find(
                    (p: any) => p.name.trim() === "DNI"
                ) || null;
                this.$refs.personToAddModal.open();
            },
            addInsured(isAssured: boolean) {
                this.beneficiaries = 'legalHeirs';
                this.addPeople = isAssured;
                const IdCUIT = this.documentTypeList.findIndex(dt => dt.id === 'J');
                if (IdCUIT !== -1) {
                    this.documentTypeList.splice(IdCUIT, 1);
                }
                this.openPersonToAddModal();
            },
            addBeneficiaries(item) {
                const existeJ = this.documentTypeList.some((p: any) => p.id === 'J');
                if (!existeJ) {
                    this.documentTypeList.push({ id: 'J', text: 'CUIT', name: "CUIT" });
                }
                this.isBeneficiaryMode = true;
                this.currentBeneficiaryItem = item;
                this.personToAddDocTypeSelected = this.documentTypeList.find(
                    (p: any) => p.name.trim() === "DNI"
                ) || null;

                this.personToAddNumDoc = "";
                this.resetPersonToAdd();
                this.$refs.personToAddModal.open();
            },
            removeBeneficiary(insuredItem, index) {
                insuredItem.beneficiariesList.splice(index, 1);
            },
            saveBeneficiary() {
                const docId = this.personToAddDocTypeSelected.id;

                if (docId === 'J') {
                    if (!this.personToAdd.lastName) {
                        NF.Notification.show({
                            type: NF.Notification.Type.ERROR,
                            title: "Error",
                            content: "Complete el nombre de la razón social.",
                            autoHideDelay: 5000
                        });
                        return;
                    }
                } else {
                    if (!this.personToAdd.firstName || !this.personToAdd.lastName) {
                        NF.Notification.show({
                            type: NF.Notification.Type.ERROR,
                            title: "Error",
                            content: "Complete el nombre y apellido del beneficiario.",
                            autoHideDelay: 5000
                        });
                        return;
                    }
                }
                if (!Array.isArray(this.currentBeneficiaryItem.beneficiariesList)) {
                    this.currentBeneficiaryItem.beneficiariesList = [];
                }

                const docTypeFound = this.documentTypeList.find((dt: any) => dt.id === docId);

                this.beneficiaryData = {
                    birthday: this.personToAdd.birthday,
                    docNum: this.personToAdd.docNum,
                    docType: { id: docId, name: docTypeFound.text },
                    firstName: this.personToAdd.firstName,
                    lastName: this.personToAdd.lastName,
                    selectedIvaCondition: this.personToAdd.selectedIvaCondition.id,
                    zipCode: this.personToAdd.locality?.split(' ').pop() || null
                };


                if (!this.personToAdd.hasLocality) {
                    this.peopleToCoverHasLocality = false;
                    this.hasBeneficiaryAddress = true;
                    this.openAdressModal();                    
                    this.$refs.personToAddModal.close();
                }
                else {
                    this.peopleToCoverHasLocality = true;
                    this.hasBeneficiaryAddress = false;
                    this.currentBeneficiaryItem.beneficiariesList.push(this.beneficiaryData);
                    this.resetPersonToAdd();
                    this.isBeneficiaryMode = false;
                    this.$refs.personToAddModal.close();
                }                  
            },
            isPersonToAddSelectedDocumentType() {
                this.isNotSelectedDocumentType = false;
                if (this.personToAddDocTypeSelected) {
                    if (this.personToAddDocTypeSelected.name !== "CUIT") {
                        this.isPerson = true;
                        this.isJuridico = false;
                    } else {
                        this.isJuridico = true;
                        this.isPerson = false;
                    }
                }
                this.personToAddNumDoc = "";
                this.resetPersonToAdd();
            },
            anterior() {
                sessionStorage.removeItem("pressBack");
                sessionStorage.setItem("pressBack", "true");
                var product = sessionStorage.getItem('productId');
                var route;
                switch (product) {
                    case "555":
                        route = 'ocassion-of-work-tab-policyOwner'
                        break;
                    case "711":
                        route = 'integro-max-tab-policyOwner'
                        break;
                    case "387":
                        route = 'ap-24-hs-tab-policyOwner'
                        break;
                    default:
                        break;
                }
                this.$router.push({
                    name: route,
                })
            },
            siguiente() {
                const personsRequiringBenef = this.insuredPeople.filter(item => item.beneficiaries === "others");
                const allHaveBenef = personsRequiringBenef.every(item =>
                    Array.isArray(item.beneficiariesList) && item.beneficiariesList.length > 0
                );
                if (!allHaveBenef) {
                    NF.Notification.show({
                        type: NF.Notification.Type.ERROR,
                        title: "Error",
                        content: "Debe agregar al menos un beneficiario para cada persona que lo requiera.",
                        autoHideDelay: 5000
                    });
                    return;
                }
                // Solo se permite avanzar si la cantidad total de asegurados es igual a peopleToCover               
                if (!this.ownerIsInsured) {
                    if (this.insuredPeople.length !== this.peopleToCover) {
                        NF.Notification.show({
                            type: NF.Notification.Type.ERROR,
                            title: "Error",
                            content: "Debe completar el total de asegurados según lo indicado.",
                            autoHideDelay: 5000
                        });
                        return;
                    }
                } else if (this.insuredPeople.length !== this.peopleToCover) {
                    NF.Notification.show({
                        type: NF.Notification.Type.ERROR,
                        title: "Error",
                        content: "La cantidad total de asegurados debe ser igual a " + this.peopleToCover,
                        autoHideDelay: 5000
                    });
                    return;
                }
                sessionStorage.setItem("pressBack", "false");
                sessionStorage.removeItem("insuredPeople");
                sessionStorage.setItem("insuredPeople", JSON.stringify(this.insuredPeople));

                var product = sessionStorage.getItem('productId');
                var route;
                switch (product) {
                    case "555":
                        route = 'ocassion-of-work-tab-optionals'
                        break;
                    case "711":
                        route = 'integro-max-tab-optionals'
                        break;
                    case "387":
                        route = 'ap-24-hs-tab-optionals'
                        break;
                    default:
                        break;
                }
                this.$router.push({
                    name: route,
                })
            },
            formatDate(dateString: string) {
                dateString = dateString.replace(/^"|"$/g, '');
                const [year, month, day] = dateString.split('T')[0].split('-');
                return `${day}/${month}/${year}`;
            },
            getFilePath() {
                FilePathService.getFilePath("UrlBase")
                    .then(response => {
                        var product = sessionStorage.getItem('productId');
                        var url;
                        switch (product) {
                            case "711":
                                url = 'integro-max'
                                break;
                            case "555":
                                url = 'ocasion-de-trabajo'
                                break;
                            case "387":
                                url = 'ap-24-hs'
                                break;
                            default:
                                break;
                        }
                        window.location.href = response + url;
                    });
            },
            getDocumentType() {
                return documentTypeService.getDocumentTypeList().then(response => {
                    if (response.length) {
                        this.documentTypeList = response.map((element: any) => ({
                            ...element,
                            id: element["id"].trim(),
                            text: element["name"].trim()
                        }));
                        this.personToAddDocTypeSelected = this.documentTypeList.find(
                            (p: any) => p.name.trim() === "DNI"
                        ) || null;
                    }
                });
            },
            getIvaConditions() {
                ivaConditionService.getIvaConditionsList().then(response => {
                    if (response.length) {
                        this.ivaConditionList = response.map((element: any) => ({
                            ...element,
                            id: element["id"].toString(),
                            text: element["name"]
                        }));
                    }
                });
            },
            addNewPerson() {
                this.personToAdd.docNum = this.personToAddNumDoc;
                this.personToAdd.docType = this.personToAddDocTypeSelected;
                this.addOrEditPerson();
            },
            setPersonToAdd(personToAdd: any) {
                this.personToAdd.activeFormPersonNotExist = false;
                this.personToAdd.isPersonExist = true;
                this.personToAdd.activeForm = true;
                this.personToAdd.docNum = this.personToAddNumDoc;
                this.personToAdd.docType = this.documentTypeList.find((p: any) => p.id.trim() === personToAdd.document.identificationTypeCode);
                this.personToAdd.birthday = personToAdd.birthday;
                this.personToAdd.firstName = personToAdd.firstName;
                this.personToAdd.lastName = personToAdd.lastName;
                this.personToAdd.email = personToAdd.email || "";
                this.personToAdd.selectedIvaCondition = personToAdd.ivaConditionFiscalId
                    ? this.ivaConditionList.find((o: any) => o.id == personToAdd.ivaConditionFiscalId || o.name == personToAdd.ivaConditionFiscalId)
                    : this.ivaConditionList.find((o: any) => o.id == 4 || o.name === "Consumidor Final");
                this.personToAdd.areaCode = personToAdd.phoneAreaCode
                    ? personToAdd.phoneAreaCode.replace(/^0+/, '')
                    : "";
                this.personToAdd.telephone = personToAdd.phoneNumber
                    ? personToAdd.phoneNumber.replace(/^15+/, '')
                    : null;
                this.personToAdd.hasLocality = personToAdd.hasLocality;
                this.personToAdd.beneficiaries = personToAdd.beneficiaries;
                if (personToAdd.address) {
                    this.personToAdd.address = { ...personToAdd.address };
                }
                if (personToAdd.document) {
                    this.personToAdd.document = personToAdd.document;
                }
                this.personToAdd.locality = personToAdd.localityName;
            },
            searchPersonToAdd() {
                NF.UI.Page.blockCustom({ message: 'Cargando datos...' });
                this.personNotExist = false;
                this.messageErrorAge = "";

                this.personToAdd = {
                    ...this.getDefaultPersonToAdd(),
                    beneficiaries: ''
                };

               //Es igual al owner o al titular?
                if (!this.isBeneficiaryMode) {
                    this.personToAdd.isEqualToPolicyOwner =
                        this.personToAddNumDoc === this.policyOwner.document.identificationNumber &&
                        this.personToAddDocTypeSelected.id === this.policyOwner.document.identificationTypeCode;
                }

                if (this.ownerIsInsured) {
                    this.personToAdd.isEqualTotitularPerson =
                        this.personToAddNumDoc === this.titularPerson?.docNum &&
                        this.personToAddDocTypeSelected.id === this.titularPerson?.docTypeSelected?.id;
                }

                //Detección de duplicados dentro de modo beneficiario
                if (this.isBeneficiaryMode) {
                    // Sólo dentro de la lista de este asegurado y no permito que se agrege a si mismo
                    const listaCurr = this.currentBeneficiaryItem.beneficiariesList || [];
                    const dupEnEsta = listaCurr.some(b =>
                        b.docType.id === this.personToAddDocTypeSelected.id &&
                        b.docNum === this.personToAddNumDoc
                    );
                    const selfAsBene =
                        this.currentBeneficiaryItem.docType.id === this.personToAddDocTypeSelected.id &&
                        this.currentBeneficiaryItem.docNum === this.personToAddNumDoc;

                    this.personToAdd.alreadyExists = dupEnEsta || selfAsBene;
                } else {
                    //no repetir un asegurado
                    this.personToAdd.alreadyExists = this.insuredPeople.some(member =>
                        member.docType.id === this.personToAddDocTypeSelected.id &&
                        member.docNum === this.personToAddNumDoc
                    );
                }
                if (this.personToAdd.alreadyExists) {
                    
                    NF.UI.Page.unblock();
                    return;
                }

                if (
                    this.personToAddNumDoc &&
                    !this.personToAdd.isEqualToPolicyOwner &&
                    !this.personToAdd.isEqualTotitularPerson
                ) {
                    const dni = this.personToAddNumDoc;
                    const docTypeSeleccionado = this.personToAddDocTypeSelected.name.trim();

                    searchPersonService
                        .GetSearchPersonData(dni, this.personToAddDocTypeSelected.id, false)
                        .then(response => {                            
                            if (response.searchPersonResult.length > 1) {
                                this.openSelectMultiplePeopleModal(response.searchPersonResult);
                                return;
                            }                            
                            if (response.searchPersonResult.length < 1) {
                                this.personNotExist = true;
                                return;
                            }
                           
                            const result = response.searchPersonResult[0];
                            if (result && (result.firstName || result.razonSocial || (result.document.identificationTypeCode="J" && result.lastName))) {
                                this.setPersonToAdd(result);
                                
                                if (!this.isBeneficiaryMode) {
                                    const ageRes = this.ageCalculate(result.birthday, 18, 65);
                                    if (!ageRes.success) {
                                        this.messageErrorAge = ageRes.message;
                                        this.personToAdd.isBirthdayCorrect = false;
                                        return;
                                    }
                                    this.messageErrorAge = '';
                                    this.personToAdd.isBirthdayCorrect = true;
                                }
                            } else {                                
                                this.personToAdd.isPersonExist = false;
                                this.personToAdd.activeFormPersonNotExist = true;
                            }
                            if (dni.length > 0 && dni.length < 9) {
                                this.personToAdd.MaximDigitSuperatedDni = false;
                            } else {
                                if (docTypeSeleccionado === 'DNI') {
                                    this.personToAdd.MaximDigitSuperatedDni = true;
                                    this.personToAdd.isPersonExist = false;
                                    this.personToAdd.activeFormPersonNotExist = true;
                                } else {
                                    this.personToAdd.MaximDigitSuperatedDni = true;
                                }
                            }
                        })
                        .finally(() => {
                            NF.UI.Page.unblock();                           
                            if (
                                !this.isPeopleWithSameIdentifierModalOpen &&
                                this.personToAdd.isPersonExist &&
                                this.personToAdd.isBirthdayCorrect
                            ) {
                                this.finallySetPersonToAddOrEdit();
                            }
                        });
                } else {
                    this.personToAddNumDoc = null;
                    NF.UI.Page.unblock();
                }
            },
            finallySetPersonToAddOrEdit() {
                if (this.personToAdd && this.personToAdd.isPersonExist && this.personToAdd.isBirthdayCorrect) {
                    if (this.isBeneficiaryMode) {
                        this.saveBeneficiary();
                    } else {
                        this.addOrEditPerson();
                    }
                }
            },
            addOrEditPerson() {
                this.personData= null,
                this.personData = {
                    beneficiaries: this.beneficiaries,
                    beneficiariesList: [],
                    id: this.insuredPeople.length + 1,
                    isPersonExist: this.personToAdd.isPersonExist,
                    birthday: this.personToAdd.birthday,
                    firstName: this.personToAdd.firstName,
                    lastName: this.personToAdd.lastName,
                    docNum: this.personToAdd.docNum,
                    docType: this.personToAdd.docType,
                    email: this.personToAdd.email,
                    selectedIvaCondition: this.personToAdd.selectedIvaCondition.id,
                    areaCode: this.personToAdd.areaCode,
                    telephone: this.personToAdd.telephone,
                    hasLocality: this.personToAdd.hasLocality,
                    MaximDigitSuperatedDni: this.personToAdd.MaximDigitSuperatedDni,
                    age: this.personToAdd.age,
                    selectedLocality: this.personToAdd.selectedLocality,
                    address: null,
                    rol: this.rolRelations,
                    zipCode: this.personToAdd.locality?.split(' ').pop() || null
                };
                
                // Si el dueño es asegurado, ya está incluido; en caso contrario, asignar el primer Titular agregado
                if (!this.addPeople) {
                    this.titularPerson = this.personData;
                }
                this.personToAddNumDoc = null;

                //validacion de direccion
                if (!this.personData.hasLocality) {
                    this.peopleToCoverHasLocality = false;
                    this.closePersonToAddModal();
                    this.openAdressModal();
                }
                else {
                    this.peopleToCoverHasLocality = true;
                    this.insuredPeople.push(this.personData);
                    this.closePersonToAddModal();
                }                
            },
            addAdressToPerson() {
                var address = {
                    StreetName: this.streetName,
                    StreetNumber: this.numDom,
                    City: {
                        CityPostalCode: this.selectedLocality.zipCode
                    }
                }

                if (!this.isBeneficiaryMode){
                    this.personData.zipCode = this.selectedLocality.zipCode;
                    this.personData.hasLocality = true;
                    this.personData.address = address;
                    this.insuredPeople.push(this.personData);
                    this.isBeneficiaryMode = false;
                }
                else{
                    this.beneficiaryData.zipCode = this.selectedLocality.zipCode;
                    this.beneficiaryData.cityCode = this.selectedLocality.id;

                    this.beneficiaryData.hasLocality = true;
                    this.beneficiaryData.address = address;
                    this.currentBeneficiaryItem.beneficiariesList.push(this.beneficiaryData);
                    this.isBeneficiaryMode = false;
                    this.beneficiaryData = {};
                }
                this.resetPersonToAdd();
                this.closeAdressModal();
            },
            openAdressModal() {
                this.$refs.addresToAddModal.open();
            },
            closeAdressModal() {
                this.$refs.addresToAddModal.close();
                this.streetName = null;
                this.numDom = null;
                this.selectedLocality = null;
                this.piso = null;
                this.numDept = null
            },
            ageCalculate(fechaNacimiento: any, edadMinima: number, edadMaxima: number) {
                return AgeService.checkAge(fechaNacimiento, edadMinima, edadMaxima);
            },
            // La validación del botón “Siguiente” considera:
            // - Si el dueño es asegurado, insuredPeople.length debe ser igual a peopleToCover.
            // - Si el dueño NO es asegurado, insuredPeople.length debe ser igual a peopleToCover
            nextButtonDisableValidation() {
                if (this.ownerIsInsured) {
                    // El dueño ya está incluido; se deben agregar (peopleToCover -1 ) asegurados adicionales.
                    this.nextButtonDisable = this.insuredPeople.length !== (this.peopleToCover);
                } else {
                    // Se debe agregar un total de peopleToCover asegurados, y entre ellos debe existir un único Titular.
                    this.nextButtonDisable = this.insuredPeople.length !== this.peopleToCover;
                }
            },            
            
            async pageCustomization() {
                var product = sessionStorage.getItem('productId');
                let defaultTitle = '';
                let actualPath = '';
                let icon = '';
                switch (product) {
                    case '711': defaultTitle = 'Integro Max'; this.productName = "apintegro"; actualPath = '/integro-max'; icon = "/Logos/AP_Integro.svg";this.product = "apintegro"; break;
                    case '555': defaultTitle = 'Ocasión de Trabajo'; this.productName = "aptrabajo"; actualPath = '/ocasion-de-trabajo'; icon = "/Logos/AP_OT.svg"; this.product = "aptrabajo"; break;
                    case '387': defaultTitle = 'AP - 24HS'; this.productName = "ap24"; actualPath = '/ap-24-hs'; icon = "/Logos/AP_24.svg"; this.product = "ap24"; break;
                }
                const actualStep = 'asegurados';
                this.icono = icon
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },
            resetPersonModalState() {
                this.personToAdd = this.getDefaultPersonToAdd();
                this.personToAddNumDoc = "";
                this.personToAddDocTypeSelected = this.documentTypeList.find((p: any) => p.name === "DNI") || null;

                this.searchButtonDisable = true;
                this.personNotExist = false;
                this.messageErrorAge = null;

                this.isBeneficiaryMode = false;
                this.beneficiaries = "legalHeirs";
                this.currentBeneficiaryItem = null;

                this.multiplePeopleWithSameIdentifier = [];
                this.personWithSameIdentifierSelected = null;
                this.multiplePeopleError = "";
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'Default' + this.product + 'GTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
        },
        watch: {
            'personToAdd.birthday'(newVal) {
                if (newVal) {
                    this.ageCalculate(newVal, 18, 65);
                }
            },
            insuredPeople(newVal, oldVal) {
                // Maximo por cantidad total
                if (newVal.length >= this.peopleToCover) {
                    this.addPeopleDisable = true;
                    this.addPeopleDisableTooltipText = `Solo se puede agregar ${this.peopleToCover} asegurado${this.peopleToCover > 1 ? 's' : ''}`;
                } else {
                    this.addPeopleDisable = false;
                    this.addPeopleDisableTooltipText = "";
                } 

                this.nextButtonDisableValidation();
            }           
        },
        async mounted() {
            NF.UI.Page.block();
            
            this.vigencyStart = this.formatDate(sessionStorage.getItem("vigencyStart") || "");

            await this.pageCustomization();
            await this.getDocumentType();
            this.getIvaConditions();

            const planDataSelected = JSON.parse(sessionStorage.getItem("PlanSelected") || "null");
            if (planDataSelected) {
                this.DataPlan = planDataSelected;
                this.primerCuota = this.DataPlan.premioMensual;
                this.hasDiscount = this.DataPlan.hasDiscount;
                this.premiumWithoutDiscount = this.DataPlan.hasDiscount ? this.DataPlan.premiumWithoutDiscount : null;
                this.capital = this.DataPlan.capital;
                this.coversDetail = planDataSelected.calculosFinales;
            }
            this.ownerIsInsured = JSON.parse(sessionStorage.getItem("ownerIsInsured") || "false");
            this.policyOwner = JSON.parse(sessionStorage.getItem("contratante") || "null");

            var referente = sessionStorage.getItem("Referente");
            referente == 'null' || referente == null ? this.referente = null : this.referente = referente;

            this.updateByProductGoogleAnalytics();

            window.globalThis.dataLayer.push({
                'pas': null,
                'email': this.policyOwner.email,
                'product': this.product,
                'event': 'cotizador-' + this.product + '-datos-persona-cubrir',
                'referente': this.referente
            });

            var peopleInsured = JSON.parse(sessionStorage.getItem("insuredPeople"));
            if (peopleInsured != null) {
                this.insuredPeople = peopleInsured;
            }
            else {
                if (this.ownerIsInsured) {
                    this.titularPerson = this.policyOwner;
                    if (this.policyOwner) {

                        if (!this.policyOwner.addresFromFront) {

                            var ciudad = this.policyOwner.localityName;
                            var partes = ciudad.split(" ");
                            var zip = partes[partes.length - 1];
                            this.policyOwner.zipCode = zip;
                        }

                        const docTypeFound = this.documentTypeList.find((dt: any) => dt.id === this.policyOwner.document.identificationTypeCode);
                        const docType = docTypeFound
                            ? { id: docTypeFound.id, name: docTypeFound.text }
                            : { id: this.policyOwner.document.identificationTypeCode, name: (this.policyOwner.document.identificationTypeName || "").trim() };
                        const titularData = {
                            beneficiaries: this.policyOwner.beneficiaries,
                            beneficiariesList: [],
                            id: 1,
                            isPersonExist: true,
                            birthday: this.policyOwner.birthday,
                            firstName: this.policyOwner.firstName,
                            lastName: this.policyOwner.lastName,
                            docNum: this.policyOwner.document.identificationNumber || '',
                            docType: docType,
                            email: this.policyOwner.email,
                            selectedIvaCondition: this.policyOwner.ivaConditionFiscalId.toString(),
                            areaCode: this.policyOwner.phoneAreaCode,
                            telephone: this.policyOwner.phoneNumber,
                            hasLocality: this.policyOwner.hasLocality,
                            MaximDigitSuperatedDni: false,
                            age: "",
                            selectedLocality: null,
                            address: this.policyOwner.address,
                            rol: this.rolRelations[0],
                            zipCode: this.policyOwner.zipCode || null,
                            cityCode: this.policyOwner.cityCode || null,
                        };
                        this.insuredPeople.push(titularData);
                    }
                } else {
                    this.titularPerson = null;
                }
            }
            this.peopleToCover = parseInt(sessionStorage.getItem("peopleToCover"));
            if (this.peopleToCover === 1 && this.ownerIsInsured) {
                this.showAddInsuredButton = true;
            }
            NF.UI.Page.unblock();
        }
    });
